import { useStationsWithAudit } from '@app/modules/audit/hooks/useStationsWithAudit';
import { SelectField } from '@mi-front/ui';
import { useIntl } from 'react-intl';

export const GipStationsField_v1 = () => {
  const { $t } = useIntl();
  const stations = useStationsWithAudit();

  return (
    <SelectField
      isSearchable
      name="stations"
      label={$t({
        id: 'audit.gipReport.form.stations',
        defaultMessage: 'Emisoras',
      })}
      placeholder={$t({
        id: 'audit.gipReport.form.allStationsDefault',
        defaultMessage: 'Todas las emisoras',
      })}
      options={stations}
      multiple
      isClearable
      getOptionValue={(station) => station.id}
      getOptionLabel={(station) => station.name}
    />
  );
};
